import React, { useState } from 'react'
import { NameText } from 'src/components/Global/Text/TitleText'
import { updateAvatarAction } from 'src/redux/actions/profileAction'
import { useDispatch } from 'react-redux'
import { useCloudinaryUpload } from 'src/hooks/UseCloudinary'
import { Wrapper, useStyles } from './style'
import useSnackbar from 'src/hooks/useSnackBar'
import useUserData from 'src/hooks/useUserData'

const AvatarUpload = () => {
  const USER_DATA = useUserData()
  let profile_picture: any
  USER_DATA
    ? (profile_picture = USER_DATA.user.profile_picture)
    : (profile_picture = null)
  const classes = useStyles()
  const [file, setFile] = useState('')
  const avatar = profile_picture ? profile_picture : null
  const dispatch = useDispatch()
  const { upload } = useCloudinaryUpload()

  function handleChange(e: any) {
    let url = URL.createObjectURL(e.target.files[0])
    setFile(url)
    upload(e.target.files[0]).then(({ loading, uri, error }) => {
      handleSubmit(uri)
    })
  }

  const handleSubmit = (avatar: any) => {
    const payload = {
      avatar: avatar,
    }
    dispatch(updateAvatarAction({ payload, onSuccess, onError }))
  }
  const snackbar = useSnackbar()

  const onSuccess = (msg: any) => {
    snackbar.trigger({
      message: msg,
      severity: 'success',
    })
  }

  const onError = (error: any) => {
    snackbar.trigger({
      message: 'Error uploading avatar',
      severity: 'error',
    })
  }

  return (
    <Wrapper>
      <div className="upload">
        <div className="item">
          {file.length > 0 ? (
            <img src={file} alt="" className="profileImage" />
          ) : (
            <img src={avatar} alt="" className="profileImage" />
          )}
        </div>
        <div className="round">
          <div className={classes.divForm}>
            <input type="file" onChange={handleChange} name="upload-photo" />
          </div>
        </div>
        <NameText>
          {USER_DATA ? (
            <div className="username">
              <h2 className="title">
                {USER_DATA.user.first_name} {USER_DATA.user.last_name}
              </h2>
            </div>
          ) : null}
        </NameText>
      </div>
    </Wrapper>
  )
}
export { AvatarUpload }
